import { render, staticRenderFns } from "./btn-more.vue?vue&type=template&id=110eb9a0&scoped=true"
import script from "./btn-more.vue?vue&type=script&lang=ts"
export * from "./btn-more.vue?vue&type=script&lang=ts"
import style0 from "./btn-more.vue?vue&type=style&index=0&id=110eb9a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110eb9a0",
  null
  
)

export default component.exports